
import { css } from 'lit';
export default css`
/* Apply CSS Variables to the host element. */
:host{
  --sic-video-wrapper--padding-top-bottom:clamp(
    var(--spacing-05),
    calc(0.43rem + 5.37vw),
    var(--spacing-20)
  );
  --sic-video--default--description-spacing:var(--spacing-04);
  --sic-video--default--cta-spacing:var(--spacing-06);
  --sic-video--default--description-font-size:var(--body-03-font-size);
}
`;